// extracted by mini-css-extract-plugin
export default {"container":"Completion_container__K1vqd","okBtn":"Completion_okBtn__LkZVD","contactEmail":"Completion_contactEmail__np74+","sendEmail":"Completion_sendEmail__teLmI"};